'use client'

import { PropsWithChildren } from 'react'
import { motion } from 'motion/react'
import { usePrefersReducedMotion } from './usePrefersReducedMotion'
import { MORPH_TRANSITION } from './constants'

type MorphDialogTriggerProps = {
  morphId: string
  isOpen: boolean
  className?: string
}

export function MorphDialogTrigger({
  morphId,
  isOpen,
  className,
  children,
}: PropsWithChildren<MorphDialogTriggerProps>) {
  const prefersReducedMotion = usePrefersReducedMotion()

  if (isOpen) {
    return (
      <div className={className} style={{ visibility: 'hidden' }} aria-hidden>
        {children}
      </div>
    )
  }

  if (prefersReducedMotion) {
    return <div className={className}>{children}</div>
  }

  return (
    <motion.div
      layoutId={`morph-container-${morphId}`}
      className={className}
      style={{ borderRadius: 12, originY: 1 }}
      transition={MORPH_TRANSITION.layout}
    >
      {children}
    </motion.div>
  )
}
